module.exports = __webpack_public_path__ + "img/6-1.86d5ede9.jpg";